var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 2.60769C8.26337 2.60769 7.55683 2.88807 7.0359 3.38716C6.51496 3.88625 6.2223 4.56316 6.2223 5.26898C6.2223 5.9748 6.51496 6.65171 7.0359 7.1508C7.55683 7.64988 8.26337 7.93027 9.00008 7.93027C9.73679 7.93027 10.4433 7.64988 10.9643 7.1508C11.4852 6.65171 11.7779 5.9748 11.7779 5.26898C11.7779 4.56316 11.4852 3.88625 10.9643 3.38716C10.4433 2.88807 9.73679 2.60769 9.00008 2.60769ZM5.72644 2.13262C6.59466 1.3008 7.77223 0.833496 9.00008 0.833496C10.2279 0.833496 11.4055 1.3008 12.2737 2.13262C13.1419 2.96443 13.6297 4.09262 13.6297 5.26898C13.6297 6.44534 13.1419 7.57353 12.2737 8.40534C11.4055 9.23716 10.2279 9.70446 9.00008 9.70446C7.77223 9.70446 6.59466 9.23716 5.72644 8.40534C4.85821 7.57353 4.37045 6.44534 4.37045 5.26898C4.37045 4.09262 4.85821 2.96443 5.72644 2.13262ZM0.666748 16.8012C0.666748 13.7541 3.5705 11.4787 6.88403 11.4787H11.1161C14.4297 11.4787 17.3334 13.7541 17.3334 16.8012V18.2797C17.3334 18.7697 16.9189 19.1668 16.4075 19.1668C15.8961 19.1668 15.4816 18.7697 15.4816 18.2797V16.8012C15.4816 14.9492 13.647 13.2529 11.1161 13.2529H6.88403C4.35312 13.2529 2.5186 14.9492 2.5186 16.8012V18.2797C2.5186 18.7697 2.10405 19.1668 1.59267 19.1668C1.0813 19.1668 0.666748 18.7697 0.666748 18.2797V16.8012Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSvg);
export default __webpack_public_path__ + "static/media/profile-svg.aefe543818c9ca057b729d7e35fccd33.svg";
export { ForwardRef as ReactComponent };